import React from 'react';
import { Sprout, Target, Award, Globe, Link2, Leaf } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="pt-0 pb-0 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16 pt-20">
          <h2 className="text-4xl font-heading font-bold text-neo-black mb-4">About BloomCycle Innovations</h2>
          <p className="text-xl text-neo-gray max-w-3xl mx-auto font-body mb-12">
            Building a farmer-powered, gigaton-scale carbon removal platform.
          </p>
          
          {/* We're Building For Global Impact Section */}
          <div className="max-w-4xl mx-auto text-left mb-16">
            <h3 className="text-3xl font-heading font-bold text-neo-black mb-8 text-center">We're Building For Global Impact</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-neo-emerald/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Leaf className="w-6 h-6 text-neo-emerald" />
                </div>
                <div>
                  <h4 className="text-xl font-heading font-bold text-neo-black mb-2">Gigaton-Scale Carbon Removal</h4>
                  <p className="text-neo-gray font-body leading-relaxed">
                    BloomCycle aims to deliver 1 gigaton of measurable CO₂e removal by 2035 through enhanced biochar and modular reactor systems.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-neo-emerald/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Globe className="w-6 h-6 text-neo-emerald" />
                </div>
                <div>
                  <h4 className="text-xl font-heading font-bold text-neo-black mb-2">Farmer-Centric Climate Network</h4>
                  <p className="text-neo-gray font-body leading-relaxed">
                    We are designing a decentralized carbon removal infrastructure deployable across India, Asia-Pacific, Africa, and LATAM.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-neo-emerald/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Link2 className="w-6 h-6 text-neo-emerald" />
                </div>
                <div>
                  <h4 className="text-xl font-heading font-bold text-neo-black mb-2">Connected to Global Carbon Markets</h4>
                  <p className="text-neo-gray font-body leading-relaxed">
                    Our verified MRV stack enables farmers to participate in high-integrity global carbon credit markets with full transparency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-0">
          <div>
            <img 
              src="/rod-long-J-ygvQbilXU-unsplash-2.webp"
              alt="Rural farming"
              className="rounded-2xl shadow-2xl w-full h-96 object-cover border border-neo-emerald/20"
            />
          </div>
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl font-heading font-bold text-neo-black mb-6">Our Mission</h3>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-neo-emerald/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Sprout className="w-6 h-6 text-neo-emerald" />
                </div>
                <div>
                  <p className="text-neo-gray font-body leading-relaxed">
                    To transform agriculture into a climate solution by converting crop residues into high-quality biochar, rebuilding soil health, and income opportunities for farmers.
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-heading font-bold text-neo-black mb-6">Our Vision</h3>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-neo-emerald/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Target className="w-6 h-6 text-neo-emerald" />
                </div>
                <div>
                  <p className="text-neo-gray font-body leading-relaxed">
                    To build a sustainable, globally scalable agricultural ecosystem where every farmer contributes to climate action through innovative biochar pathways.
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-2xl font-heading font-bold text-neo-black mb-6">DPIIT Registered Startup</h3>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-neo-emerald/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Award className="w-6 h-6 text-neo-emerald" />
                </div>
                <div>
                  <p className="text-neo-gray font-body leading-relaxed">
                    BLOOMCYCLE INNOVATIONS is officially recognized by DPIIT (Department for Promotion of Industry and Internal Trade) under Startup India initiative. We are certified by government authorities, ensuring reliability, compliance, and access to agricultural schemes and carbon credit programs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
